// extracted by mini-css-extract-plugin
export var cmlIcon = "styles-module--cmlIcon--60f8b";
export var communityPopup = "styles-module--communityPopup--bd2c9";
export var description = "styles-module--description--cb29c";
export var dvcIcon = "styles-module--dvcIcon--ce8b9";
export var link = "styles-module--link--36d2e";
export var linkIcon = "styles-module--linkIcon--736e0";
export var otherPopup = "styles-module--otherPopup--f2b25";
export var otherToolsPopup = "styles-module--otherToolsPopup--c6fa9";
export var popup = "styles-module--popup--3a6b3";
export var studioIcon = "styles-module--studioIcon--bf4eb";
export var title = "styles-module--title--fd510";
export var titleExternalIcon = "styles-module--titleExternalIcon--ca427";
export var titleIcon = "styles-module--titleIcon--f9136";
export var visible = "styles-module--visible--5964c";
export var vscodeIcon = "styles-module--vscodeIcon--06511";